import { facadeApi } from 'api'
import { FeedsStatusItem } from 'types/feeds/feeds'

export const fetchFeedsStatusesApi = () => facadeApi.get<{ data: FeedsStatusItem[] }>('/feeds/status')
